import * as React from 'react';

import ApplicationStatusContainer from '../../containers/ApplicationStatus';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 申請内容確認画面
 * @param props
 */
const ApplicationStatus: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ApplicationStatus_0013')} />
			<ApplicationStatusContainer {...props} />
		</>
	);
};

export default ApplicationStatus;



// WEBPACK FOOTER //
// ./src/pages/personal/ApplicationStatus.tsx